module.exports = __webpack_public_path__ + "img/lifull_white.1fc357ee.svg";